// extracted by mini-css-extract-plugin
export default {"wrapper":"onw4xc","withIcons":"FcJtWf","ltr":"gJb7xu","user":"n0LB4J","rtl":"VqOhoa","name":"Bgn4yW","arrow":"SJoyne"};